import { render } from "./ProjectRolePermissionTab.vue?vue&type=template&id=802ca81c&scoped=true"
import script from "./ProjectRolePermissionTab.vue?vue&type=script&lang=js"
export * from "./ProjectRolePermissionTab.vue?vue&type=script&lang=js"

import "./ProjectRolePermissionTab.vue?vue&type=style&index=0&id=802ca81c&lang=scss&scoped=true"
import "./ProjectRolePermissionTab.vue?vue&type=style&index=1&id=802ca81c&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-802ca81c"]])

export default __exports__